(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afterta-tape-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-afterta-tape .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afterta-tape-story-1"]) return;
  try {
    

      (function() {
        function isMobile() { return ('ontouchstart' in window || navigator.maxTouchPoints > 0) && window.innerWidth <= 768; }
        class HolographicProductTape extends HTMLElement {
          connectedCallback() {
            this.wrapper = this.querySelector('.tape-holographic-image-wrapper');
            this.inner = this.querySelector('.tape-holographic-image-inner');
            if (this.wrapper && this.inner && !isMobile()) {
              this.wrapper.addEventListener('mousemove', (e) => {
                const rect = this.wrapper.getBoundingClientRect();
                const x = e.clientX - rect.left, y = e.clientY - rect.top;
                const centerX = rect.width/2, centerY = rect.height/2;
                let rotateX = ((y - centerY)/centerY)*-10, rotateY = ((x - centerX)/centerX)*10;
                rotateX = Math.min(Math.max(rotateX, -15), 15);
                rotateY = Math.min(Math.max(rotateY, -15), 15);
                this.inner.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`;
              });
              this.wrapper.addEventListener('mouseleave', () => {
                this.inner.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
              });
            }
          }
        }
        if (!customElements.get('holographic-product-tape')) customElements.define('holographic-product-tape', HolographicProductTape);
      })();
    

    (function() {
      class BeforeAfterSliderTape extends HTMLElement {
        constructor() { super(); this.isDragging = false; }
        connectedCallback() {
          this.container = this.querySelector('.tape-ba-images');
          this.divider = this.querySelector('[data-divider]');
          this.afterImage = this.querySelector('[data-after-image]');
          if (!this.container || !this.divider || !this.afterImage) return;
          this.setupEvents();
        }
        setupEvents() {
          this.divider.addEventListener('mousedown', this.startDrag.bind(this));
          this.divider.addEventListener('touchstart', this.startDrag.bind(this), { passive: true });
          document.addEventListener('mousemove', this.onDrag.bind(this));
          document.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
          document.addEventListener('mouseup', this.stopDrag.bind(this));
          document.addEventListener('touchend', this.stopDrag.bind(this));
          this.container.addEventListener('click', this.handleClick.bind(this));
        }
        startDrag(e) { this.isDragging = true; this.container.style.cursor = 'ew-resize'; e.preventDefault(); }
        stopDrag() { this.isDragging = false; this.container.style.cursor = 'default'; }
        onDrag(e) {
          if (!this.isDragging) return;
          const rect = this.container.getBoundingClientRect();
          const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
          let x = clientX - rect.left;
          let percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
          this.update(percentage);
        }
        handleClick(e) {
          if (e.target === this.divider || this.divider.contains(e.target)) return;
          const rect = this.container.getBoundingClientRect();
          let percentage = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          this.update(percentage);
        }
        update(percentage) {
          this.divider.style.left = percentage + '%';
          this.afterImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
        }
      }
      if (!customElements.get('before-after-slider-tape')) customElements.define('before-after-slider-tape', BeforeAfterSliderTape);
    })();
  

  (function() {
    const modules = document.querySelectorAll('.reveal-module');
    if (!modules.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('module-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -80px 0px' });
    modules.forEach(module => observer.observe(module));
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cream-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-cream .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eye-page-layout"]) return;
  try {
    
function initEyeReference(){

(function(){
  var root=document.getElementById('cc-eye-tabs');
  if(!root||root.dataset.ready==='true')return;
  root.dataset.ready='true';
  var tabs=[].slice.call(root.querySelectorAll('.ccet-tab'));
  var panels=[].slice.call(root.querySelectorAll('.ccet-panel'));
  var dots=[].slice.call(root.querySelectorAll('.ccet-dot'));
  var progress=root.querySelector('.ccet-progress');
  var tabsTrack=root.querySelector('.ccet-tabs');
  var panelArea=root.querySelector('.ccet-panels');
  var current=0,timer=null,sectionVisible=false,userInteracting=false;
  var delay=5000,mq=window.matchMedia('(max-width:749px)');

  function norm(i){if(i<0)return panels.length-1;if(i>=panels.length)return 0;return i;}
  function centerTab(){
    if(!mq.matches||!tabsTrack||!tabs[current])return;
    var t=tabs[current];
    var target=t.offsetLeft-((tabsTrack.clientWidth-t.offsetWidth)/2);
    var max=Math.max(0,tabsTrack.scrollWidth-tabsTrack.clientWidth);
    target=Math.max(0,Math.min(target,max));
    try{tabsTrack.scrollTo({left:target,behavior:'smooth'});}catch(e){tabsTrack.scrollLeft=target;}
  }
  function activate(i,opt){
    opt=opt||{};current=norm(i);
    tabs.forEach(function(t,k){var a=k===current;t.classList.toggle('is-active',a);t.setAttribute('aria-selected',a?'true':'false');t.setAttribute('tabindex',a?'0':'-1');});
    panels.forEach(function(p,k){var a=k===current;p.classList.toggle('is-active',a);p.setAttribute('aria-hidden',a?'false':'true');});
    dots.forEach(function(d,k){d.classList.toggle('is-active',k===current);});
    if(opt.centerTab===true)centerTab();
    restartProgress();
  }
  function restartProgress(){if(!progress)return;progress.classList.remove('is-running');void progress.offsetWidth;if(mq.matches&&sectionVisible&&!document.hidden&&!userInteracting)progress.classList.add('is-running');}
  function stop(){if(timer){clearInterval(timer);timer=null;}if(progress)progress.classList.remove('is-running');}
  function start(){stop();if(!mq.matches||document.hidden||!sectionVisible||userInteracting)return;restartProgress();timer=setInterval(function(){activate(current+1,{centerTab:false});},delay);}
  tabs.forEach(function(t){
    t.addEventListener('click',function(){userInteracting=true;stop();activate(Number(t.getAttribute('data-tab')),{centerTab:true});setTimeout(function(){userInteracting=false;start();},800);});
    t.addEventListener('keydown',function(e){var i=tabs.indexOf(t),n=null;if(e.key==='ArrowRight')n=norm(i+1);if(e.key==='ArrowLeft')n=norm(i-1);if(n===null)return;e.preventDefault();userInteracting=true;stop();activate(n,{centerTab:true});if(tabs[n])tabs[n].focus({preventScroll:true});setTimeout(function(){userInteracting=false;start();},800);});
  });
  dots.forEach(function(d){d.addEventListener('click',function(){userInteracting=true;stop();activate(Number(d.getAttribute('data-dot')),{centerTab:true});setTimeout(function(){userInteracting=false;start();},800);});});
  if(panelArea){
    var sx=0,sy=0;
    panelArea.addEventListener('touchstart',function(e){if(!e.touches||!e.touches.length)return;sx=e.touches[0].clientX;sy=e.touches[0].clientY;userInteracting=true;stop();},{passive:true});
    panelArea.addEventListener('touchend',function(e){if(!mq.matches||!e.changedTouches||!e.changedTouches.length){userInteracting=false;start();return;}var ex=e.changedTouches[0].clientX,ey=e.changedTouches[0].clientY,dx=ex-sx,dy=ey-sy;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){if(dx<0)activate(current+1,{centerTab:true});else activate(current-1,{centerTab:true});}setTimeout(function(){userInteracting=false;start();},450);},{passive:true});
  }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(en){en.forEach(function(e){if(e.target!==root)return;sectionVisible=e.isIntersecting&&e.intersectionRatio>0.08;if(sectionVisible)start();else stop();});},{threshold:[0,0.08,0.25,0.5]}).observe(root);
  }else{sectionVisible=true;}
  document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else if(sectionVisible)start();});
  activate(0,{centerTab:false});
})();


(function(){
  const root = document.getElementById('cc-technology-template--27853380845850__custom_liquid_9GENjy');

  if(!root) return;

  const buttons = Array.from(root.querySelectorAll('.cct-nav-button'));
  const panels = Array.from(root.querySelectorAll('.cct-panel'));
  const dots = Array.from(root.querySelectorAll('.cct-dot'));

  const progress = root.querySelector('.cct-progress');
  const mobileNav = root.querySelector('.cct-nav');

  let current = 0;
  let timer = null;
  let sectionVisible = false;
  let userInteracting = false;
  const delay = 5200;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function stopAutoplay(){
    if(timer !== null){
      window.clearInterval(timer);
      timer = null;
    }
  }

  function startAutoplay(){
    stopAutoplay();
    if(!mobileQuery.matches || !sectionVisible || document.hidden || userInteracting){
      return;
    }
    timer = window.setInterval(function(){
      if(!sectionVisible || document.hidden || userInteracting){
        return;
      }
      activate(current + 1);
    }, delay);
  }

  function restartProgress(){
    if(!progress) return;
    progress.classList.remove('is-running');
    void progress.offsetWidth;
    if(mobileQuery.matches && sectionVisible){
      progress.classList.add('is-running');
    }
  }

  function centerNavButton(index){
    if(!mobileNav || !mobileQuery.matches || !buttons[index]) return;
    const button = buttons[index];
    const targetLeft = button.offsetLeft - (mobileNav.clientWidth - button.offsetWidth) / 2;
    mobileNav.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: 'smooth'
    });
  }

  function activate(index){
    if(!panels.length) return;
    if(index < 0) index = panels.length - 1;
    if(index >= panels.length) index = 0;
    current = index;

    buttons.forEach(function(button, i){
      const active = i === current;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function(panel, i){
      panel.classList.toggle('is-active', i === current);
    });

    dots.forEach(function(dot, i){
      dot.classList.toggle('is-active', i === current);
    });

    centerNavButton(current);
    restartProgress();
  }

  buttons.forEach(function(button){
    button.addEventListener('click', function(){
      userInteracting = true;
      stopAutoplay();
      const index = Number(button.getAttribute('data-tech'));
      activate(index);
      window.setTimeout(function(){
        userInteracting = false;
        startAutoplay();
      }, 700);
    });
  });

  dots.forEach(function(dot){
    dot.addEventListener('click', function(){
      userInteracting = true;
      stopAutoplay();
      const index = Number(dot.getAttribute('data-dot'));
      activate(index);
      window.setTimeout(function(){
        userInteracting = false;
        startAutoplay();
      }, 700);
    });
  });

  if(mobileNav){
    mobileNav.addEventListener('touchstart', function(){
      userInteracting = true;
      stopAutoplay();
    }, { passive:true });

    mobileNav.addEventListener('touchend', function(){
      window.setTimeout(function(){
        userInteracting = false;
        startAutoplay();
      }, 500);
    }, { passive:true });

    mobileNav.addEventListener('wheel', function(event){
      if(mobileQuery.matches && Math.abs(event.deltaY) > Math.abs(event.deltaX)){
        mobileNav.scrollLeft += event.deltaY;
      }
    }, { passive:true });
  }

  if('IntersectionObserver' in window){
    const observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.target !== root) return;
        sectionVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        if(sectionVisible){
          restartProgress();
          startAutoplay();
        }else{
          stopAutoplay();
          if(progress){
            progress.classList.remove('is-running');
          }
        }
      });
    }, { threshold: [0, 0.25, 0.5] });
    observer.observe(root);
  } else {
    sectionVisible = false;
  }

  document.addEventListener('visibilitychange', function(){
    if(document.hidden){
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });

  function handleResponsiveChange(){
    stopAutoplay();
    restartProgress();
    startAutoplay();
  }

  if(typeof mobileQuery.addEventListener === 'function'){
    mobileQuery.addEventListener('change', handleResponsiveChange);
  } else if(typeof mobileQuery.addListener === 'function'){
    mobileQuery.addListener(handleResponsiveChange);
  }

  activate(0);
})();


(function(){
  const root = document.getElementById('cc-four-reasons-template--27853380845850__custom_liquid_06reason3');

  if(!root){
    return;
  }

  const buttons = [...root.querySelectorAll('.ccfr-nav-btn')];
  const reasons = [...root.querySelectorAll('.ccfr-reason')];

  function activateReason(index, shouldScroll){
    if(index < 0 || index >= reasons.length){
      return;
    }

    buttons.forEach(function(button, i){
      button.classList.toggle('is-active', i === index);
    });

    if(shouldScroll && reasons[index]){
      const rect = reasons[index].getBoundingClientRect();
      const targetY = window.scrollY + rect.top - 28;
      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });
    }
  }

  buttons.forEach(function(button, index){
    button.addEventListener('click', function(){
      activateReason(index, true);
    });
  });

  const observer = new IntersectionObserver(
    function(entries){
      let bestIndex = 0;
      let bestRatio = 0;

      entries.forEach(function(entry){
        if(entry.isIntersecting && entry.intersectionRatio > bestRatio){
          bestRatio = entry.intersectionRatio;
          bestIndex = reasons.indexOf(entry.target);
        }
      });

      if(bestRatio > .30 && bestIndex >= 0){
        buttons.forEach(function(button, i){
          button.classList.toggle('is-active', i === bestIndex);
        });
      }
    },
    {
      threshold: [.20, .35, .50, .65]
    }
  );

  reasons.forEach(function(reason){
    observer.observe(reason);
  });
})();


(function(){
  const root = document.getElementById('cc-video-reels-container');
  if(!root) return;

  const slider = root.querySelector('[data-video-slider]');
  const cards = [...root.querySelectorAll('.ccvr-card')];
  const videos = [...root.querySelectorAll('.ccvr-video')];
  const dots = [...root.querySelectorAll('.ccvr-dot')];
  const prev = root.querySelector('.ccvr-prev');
  const next = root.querySelector('.ccvr-next');

  let activeIndex = 0;
  let sectionVisible = false;
  let userPaused = false;
  let scrollTimer = null;
  let isProgrammaticScroll = false;

  function pauseAllVideos(resetTime = false) {
    videos.forEach(video => {
      try {
        video.pause();
        if(resetTime) video.currentTime = 0;
      } catch(e) {}
    });
  }

  function resetPlayingBars() {
    cards.forEach(card => {
      const bar = card.querySelector('.ccvr-playing-bar span');
      if(bar) bar.style.width = '0%';
    });
  }

  function updateActiveUI(index) {
    activeIndex = index;
    cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  function getCenteredScrollLeft(card) {
    if(!slider || !card) return 0;
    return Math.max(0, card.offsetLeft - (slider.clientWidth - card.clientWidth) / 2);
  }

  function getClosestCardIndex() {
    if(!slider || !cards.length) return 0;
    const sliderRect = slider.getBoundingClientRect();
    const sliderCenter = sliderRect.left + sliderRect.width / 2;
    let closest = 0;
    let closestDistance = Infinity;
    cards.forEach((card, index) => {
      const rect = card.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      const distance = Math.abs(center - sliderCenter);
      if(distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });
    return closest;
  }

  function playCurrentVideo() {
    if(!sectionVisible || !videos[activeIndex] || userPaused) return;
    pauseAllVideos(false);
    const video = videos[activeIndex];
    video.muted = true;
    video.playsInline = true;
    const playPromise = video.play();
    if(playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function setActiveCard(index, options = {}) {
    const shouldCenter = options.center !== false;
    const autoplay = options.autoplay !== false;
    if(index < 0 || index >= cards.length) return;

    userPaused = false;
    pauseAllVideos(true);
    resetPlayingBars();
    updateActiveUI(index);

    if(shouldCenter && slider) {
      const target = getCenteredScrollLeft(cards[index]);
      isProgrammaticScroll = true;
      slider.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(() => { isProgrammaticScroll = false; }, 500);
    }

    if(autoplay) {
      setTimeout(() => {
        playCurrentVideo();
      }, shouldCenter ? 280 : 60);
    }
  }

  function nextCard() {
    const nextIndex = activeIndex + 1 >= cards.length ? 0 : activeIndex + 1;
    setActiveCard(nextIndex);
  }

  function previousCard() {
    const previousIndex = activeIndex - 1 < 0 ? cards.length - 1 : activeIndex - 1;
    setActiveCard(previousIndex);
  }

  if(next) next.addEventListener('click', nextCard);
  if(prev) prev.addEventListener('click', previousCard);

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = Number(dot.getAttribute('data-index'));
      setActiveCard(index);
    });
  });

  videos.forEach((video, index) => {
    video.addEventListener('play', () => {
      userPaused = false;
      videos.forEach((other, otherIndex) => {
        if(other !== video) {
          try {
            other.pause();
            other.currentTime = 0;
          } catch(e) {}
        }
      });
      resetPlayingBars();
      updateActiveUI(index);
    });

    video.addEventListener('pause', () => {
      if(!video.ended && video.currentTime > 0) {
        if(index === activeIndex) userPaused = true;
      }
    });

    video.addEventListener('ended', () => {
      userPaused = false;
      if(index === activeIndex && sectionVisible) nextCard();
    });

    video.addEventListener('timeupdate', () => {
      if(index !== activeIndex) return;
      if(!video.duration || !isFinite(video.duration)) return;
      const percent = (video.currentTime / video.duration) * 100;
      const bar = cards[index].querySelector('.ccvr-playing-bar span');
      if(bar) bar.style.width = Math.min(100, Math.max(0, percent)) + '%';
    });
  });

  function updateFromScroll() {
    if(isProgrammaticScroll) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const closest = getClosestCardIndex();
      if(closest !== activeIndex) {
        setActiveCard(closest, { center: false, autoplay: true });
      } else {
        playCurrentVideo();
      }
    }, 120);
  }

  if(slider) {
    slider.addEventListener('scroll', updateFromScroll, { passive: true });

    let touchStartX = 0, touchStartY = 0;
    slider.addEventListener('touchstart', (event) => {
      userPaused = false;
      if(event.touches && event.touches.length) {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }
    }, { passive: true });

    slider.addEventListener('touchend', (event) => {
      if(!event.changedTouches || !event.changedTouches.length) return;
      const touch = event.changedTouches[0];
      const diffX = touch.clientX - touchStartX;
      const diffY = touch.clientY - touchStartY;
      if(Math.abs(diffX) > 45 && Math.abs(diffX) > Math.abs(diffY)) {
        if(diffX < 0) nextCard(); else previousCard();
      }
    }, { passive: true });

    let mouseDown = false, mouseStartX = 0;
    slider.addEventListener('mousedown', (event) => {
      mouseDown = true;
      mouseStartX = event.clientX;
      userPaused = false;
    });

    window.addEventListener('mouseup', (event) => {
      if(!mouseDown) return;
      mouseDown = false;
      const difference = event.clientX - mouseStartX;
      if(Math.abs(difference) > 50) {
        if(difference < 0) nextCard(); else previousCard();
      }
    });
  }

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        sectionVisible = true;
        setTimeout(() => { playCurrentVideo(); }, 150);
      } else {
        sectionVisible = false;
        pauseAllVideos(false);
      }
    });
  }, { threshold: 0.45 });
  sectionObserver.observe(root);

  document.addEventListener('visibilitychange', () => {
    if(document.hidden) {
      pauseAllVideos(false);
    } else if(sectionVisible) {
      setTimeout(() => { playCurrentVideo(); }, 180);
    }
  });

  updateActiveUI(0);
  pauseAllVideos(true);
})();


(function(){
  const root = document.getElementById('cc-customer-stories');
  if(!root) return;

  const slider = root.querySelector('.ccs-slider');
  const cards = [...root.querySelectorAll('.ccs-card')];
  const dots = [...root.querySelectorAll('.ccs-dot')];
  const prev = root.querySelector('.ccs-prev');
  const next = root.querySelector('.ccs-next');
  const progress = root.querySelector('.ccs-progress');

  if(!slider || !cards.length) return;

  let current = 0;
  let timer = null;
  let sectionVisible = false;
  let interacting = false;
  let scrollTimer = null;
  const delay = 6200;

  function getCardScrollLeft(index) {
    const card = cards[index];
    if(!card) return 0;
    return Math.max(0, card.offsetLeft - (slider.clientWidth - card.offsetWidth) / 2);
  }

  function getClosestCardIndex() {
    const sliderRect = slider.getBoundingClientRect();
    const sliderCenter = sliderRect.left + sliderRect.width / 2;
    let closest = 0;
    let closestDistance = Infinity;
    cards.forEach((card, index) => {
      const rect = card.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      const distance = Math.abs(center - sliderCenter);
      if(distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });
    return closest;
  }

  function updateUI(index) {
    current = index;
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
  }

  function restartProgress() {
    if(!progress) return;
    progress.classList.remove('is-running');
    void progress.offsetWidth;
    if(sectionVisible) progress.classList.add('is-running');
  }

  function goTo(index, smooth = true) {
    if(index < 0) index = cards.length - 1;
    if(index >= cards.length) index = 0;
    updateUI(index);
    slider.scrollTo({
      left: getCardScrollLeft(index),
      behavior: smooth ? 'smooth' : 'auto'
    });
    restartProgress();
  }

  function stopAutoplay() {
    if(timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function startAutoplay() {
    stopAutoplay();
    if(!sectionVisible || document.hidden || interacting || cards.length < 2) return;
    timer = setInterval(() => {
      if(!sectionVisible || interacting || document.hidden) return;
      goTo(current + 1, true);
    }, delay);
  }

  if(prev) {
    prev.addEventListener('click', () => {
      interacting = true;
      stopAutoplay();
      goTo(current - 1, true);
      setTimeout(() => { interacting = false; startAutoplay(); }, 450);
    });
  }

  if(next) {
    next.addEventListener('click', () => {
      interacting = true;
      stopAutoplay();
      goTo(current + 1, true);
      setTimeout(() => { interacting = false; startAutoplay(); }, 450);
    });
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = Number(dot.getAttribute('data-index'));
      interacting = true;
      stopAutoplay();
      goTo(index, true);
      setTimeout(() => { interacting = false; startAutoplay(); }, 450);
    });
  });

  let touchStartX = 0, touchStartY = 0;

  slider.addEventListener('touchstart', (event) => {
    stopAutoplay();
    interacting = true;
    if(event.touches && event.touches.length) {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }
  }, { passive: true });

  slider.addEventListener('touchend', (event) => {
    let changed = false;
    if(event.changedTouches && event.changedTouches.length) {
      const touch = event.changedTouches[0];
      const diffX = touch.clientX - touchStartX;
      const diffY = touch.clientY - touchStartY;
      if(Math.abs(diffX) > 45 && Math.abs(diffX) > Math.abs(diffY)) {
        changed = true;
        if(diffX < 0) goTo(current + 1, true);
        else goTo(current - 1, true);
      }
    }
    setTimeout(() => {
      current = getClosestCardIndex();
      updateUI(current);
      interacting = false;
      restartProgress();
      startAutoplay();
    }, changed ? 350 : 180);
  }, { passive: true });

  slider.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const index = getClosestCardIndex();
      updateUI(index);
    }, 100);
  }, { passive: true });

  let mouseDown = false, mouseStartX = 0;

  slider.addEventListener('mousedown', (event) => {
    mouseDown = true;
    mouseStartX = event.clientX;
    stopAutoplay();
    interacting = true;
  });

  window.addEventListener('mouseup', (event) => {
    if(!mouseDown) return;
    mouseDown = false;
    const diff = event.clientX - mouseStartX;
    if(Math.abs(diff) > 50) {
      if(diff < 0) goTo(current + 1, true);
      else goTo(current - 1, true);
    } else {
      goTo(getClosestCardIndex(), true);
    }
    interacting = false;
    startAutoplay();
  });

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      sectionVisible = entry.isIntersecting;
      if(sectionVisible) {
        current = getClosestCardIndex();
        updateUI(current);
        restartProgress();
        startAutoplay();
      } else {
        stopAutoplay();
        interacting = false;
      }
    });
  }, { threshold: 0.35 });
  sectionObserver.observe(root);

  document.addEventListener('visibilitychange', () => {
    if(document.hidden) stopAutoplay();
    else startAutoplay();
  });

  updateUI(0);
  goTo(0, false);
})();

}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initEyeReference,{once:true})}else{initEyeReference()}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["face-patches-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-face-patches .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faith-coin-story"]) return;
  try {
    
(function () {
  function setupCoinMedia() {
    document.querySelectorAll('.coin-story').forEach(function (root) {
      if (root.dataset.coinMediaReady) return;
      root.dataset.coinMediaReady = 'true';
      var rail = root.querySelector('.coin-media-grid');
      root.querySelectorAll('[data-coin-media-direction]').forEach(function (button) {
        button.addEventListener('click', function () {
          rail.scrollBy({left: (rail.querySelector('figure').getBoundingClientRect().width + 20) * Number(button.dataset.coinMediaDirection), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
      });
      root.querySelectorAll('video').forEach(function (video) {
        video.defaultMuted = true;
        video.muted = true;
        video.controls = false;
        var playback = video.play();
        if (playback && playback.catch) playback.catch(function () {});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCoinMedia); else setupCoinMedia();
  document.addEventListener('shopify:section:load', setupCoinMedia);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gel-page-layout"]) return;
  try {
    
function initGelReference(){
  (function () {
    var root = document.getElementById('detail-stats-template--25601379729698__new_detail_clinical_results_4QcFnr');
    if (!root) return;

    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animateValue(el) {
      var raw = el.textContent.trim();
      var match = raw.match(/^(-?\d+(?:\.\d+)?)(.*)$/);
      if (!match) return;

      var target = parseFloat(match[1]);
      var suffix = match[2] || '';
      var decimals = (match[1].split('.')[1] || '').length;

      if (isNaN(target)) return;

      var finalText = target.toFixed(decimals) + suffix;

      if (prefersReducedMotion) {
        el.textContent = finalText;
        return;
      }

      el.textContent = finalText;
      el.style.display = 'inline-block';
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
      el.style.textAlign = 'center';

      var card = el.closest('.detail-stats__card');
      if (card) {
        card.style.minHeight = card.getBoundingClientRect().height + 'px';
      }

      var duration = 1200;
      var startTime = null;

      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          el.textContent = finalText;
        }
      }

      window.requestAnimationFrame(step);
    }

    var numbers = root.querySelectorAll('.detail-stats__value-number');
    if (!numbers.length) return;

    if (!('IntersectionObserver' in window)) {
      numbers.forEach(animateValue);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            numbers.forEach(animateValue);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(root);
  })();

(function(){var root=document.getElementById('vxReviewCarousel');if(!root)return;var track=root.querySelector('.vx-review-carousel__swiper');var cards=Array.from(root.querySelectorAll('.swiper-slide'));var index=0;function move(d){index=(index+d+cards.length)%cards.length;var left=cards[index].offsetLeft-cards[0].offsetLeft;track.scrollTo({left:left,behavior:'smooth'})}root.querySelector('.vx-review-carousel__arrow--prev')?.addEventListener('click',()=>move(-1));root.querySelector('.vx-review-carousel__arrow--next')?.addEventListener('click',()=>move(1));})();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initGelReference,{once:true})}else{initGelReference()}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gel-reference-2"]) return;
  try {
    
function gelHeroFallback(){document.querySelectorAll('[data-gel-fallback]').forEach(function(img){function fallback(){var url=img.getAttribute('data-gel-fallback');if(img.src!==url){img.removeAttribute('srcset');img.src=url}}img.addEventListener('error',fallback,{once:true});if(img.complete&&!img.naturalWidth)fallback()})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',gelHeroFallback,{once:true})}else{gelHeroFallback()}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gum-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-gum .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kikoora-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-kikoora .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["niacinamide-foam-reviews"]) return;
  try {
    


(function(){

  var root =
    document.getElementById(
      'lovqo-review-v6'
    );

  if(!root){
    return;
  }

  
  if(root.dataset.lrInitialized === 'true'){
    return;
  }

  root.dataset.lrInitialized = 'true';



  

  var photoViewport =
    root.querySelector(
      '.lr-photo-viewport'
    );

  var photoTrack =
    root.querySelector(
      '.lr-photos'
    );

  var photoPrev =
    root.querySelector(
      '.lr-photo-prev'
    );

  var photoNext =
    root.querySelector(
      '.lr-photo-next'
    );

  var photoDotsWrap =
    root.querySelector(
      '.lr-photo-dots'
    );


  
  Array.prototype.slice.call(
    photoTrack.querySelectorAll(
      '.lr-photo[aria-hidden="true"]'
    )
  ).forEach(function(clone){
    clone.remove();
  });

  photoDotsWrap.innerHTML = '';

  photoTrack.style.transition = 'none';
  photoTrack.style.transform = 'translate3d(0,0,0)';


  var originalPhotos =
    Array.prototype.slice.call(
      photoTrack.querySelectorAll(
        '.lr-photo:not([aria-hidden="true"])'
      )
    );


  var photoCount =
    originalPhotos.length;


  var photoIndex = 0;

  var photoTimer = null;


  var photoTransition =
    'transform .58s cubic-bezier(.22,.61,.36,1)';



  

  originalPhotos.forEach(
    function(photo){

      var clone =
        photo.cloneNode(true);

      clone.setAttribute(
        'aria-hidden',
        'true'
      );

      var image =
        clone.querySelector('img');

      if(image){
        image.alt = '';
      }

      photoTrack.appendChild(
        clone
      );

    }
  );



  

  for(
    var i = 0;
    i < photoCount;
    i++
  ){

    var dot =
      document.createElement(
        'button'
      );

    dot.type =
      'button';

    dot.className =
      'lr-photo-dot';

    dot.setAttribute(
      'data-photo',
      i
    );

    dot.setAttribute(
      'aria-label',
      'Show customer photo ' +
      (i + 1)
    );

    if(i === 0){
      dot.classList.add(
        'active'
      );
    }

    photoDotsWrap.appendChild(
      dot
    );

  }


  var photoDots =
    photoDotsWrap.querySelectorAll(
      '.lr-photo-dot'
    );



  

  function getPhotoStep(){

    var slide =
      photoTrack.querySelector(
        '.lr-photo'
      );

    if(!slide){
      return 0;
    }


    var slideWidth =
      slide
        .getBoundingClientRect()
        .width;


    var styles =
      window.getComputedStyle(
        photoTrack
      );


    var gap =
      parseFloat(
        styles.columnGap ||
        styles.gap ||
        0
      );


    return slideWidth + gap;

  }



  

  function setPhotoPosition(
    animate
  ){

    if(animate){

      photoTrack.style.transition =
        photoTransition;

    }else{

      photoTrack.style.transition =
        'none';

    }


    var step =
      getPhotoStep();


    photoTrack.style.transform =
      'translate3d(-' +
      (
        photoIndex *
        step
      ) +
      'px,0,0)';


    var logicalIndex =
      (
        (
          photoIndex %
          photoCount
        ) +
        photoCount
      ) %
      photoCount;


    photoDots.forEach(
      function(dot,index){

        dot.classList.toggle(
          'active',
          index === logicalIndex
        );

      }
    );

  }



  

  function nextPhoto(){

    photoIndex += 1;

    setPhotoPosition(
      true
    );

  }



  

  function previousPhoto(){

    if(photoIndex === 0){

      photoIndex =
        photoCount;

      setPhotoPosition(
        false
      );

      photoTrack.offsetHeight;

    }


    photoIndex -= 1;

    setPhotoPosition(
      true
    );

  }



  

  photoTrack.addEventListener(
    'transitionend',
    function(){

      if(
        photoIndex >=
        photoCount
      ){

        photoIndex =
          photoIndex %
          photoCount;


        setPhotoPosition(
          false
        );


        photoTrack.offsetHeight;


        photoTrack.style.transition =
          photoTransition;

      }

    }
  );



  

  function stopPhotoAutoplay(){

    if(photoTimer){

      clearInterval(
        photoTimer
      );

      photoTimer =
        null;

    }

  }


  function startPhotoAutoplay(){

    stopPhotoAutoplay();


    if(
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ){

      return;

    }


    photoTimer =
      setInterval(
        nextPhoto,
        2800
      );

  }



  

  photoPrev.addEventListener(
    'click',
    function(){

      previousPhoto();

      startPhotoAutoplay();

    }
  );


  photoNext.addEventListener(
    'click',
    function(){

      nextPhoto();

      startPhotoAutoplay();

    }
  );



  

  photoDots.forEach(
    function(dot){

      dot.addEventListener(
        'click',
        function(){

          var requested =
            parseInt(
              this.getAttribute(
                'data-photo'
              ),
              10
            ) || 0;


          photoIndex =
            requested;


          setPhotoPosition(
            true
          );


          startPhotoAutoplay();

        }
      );

    }
  );



  

  var photoSection =
    root.querySelector(
      '.lr-photo-section'
    );


  photoSection.addEventListener(
    'mouseenter',
    stopPhotoAutoplay
  );


  photoSection.addEventListener(
    'mouseleave',
    startPhotoAutoplay
  );


  photoSection.addEventListener(
    'focusin',
    stopPhotoAutoplay
  );


  photoSection.addEventListener(
    'focusout',
    startPhotoAutoplay
  );



  

  var touchStartX = null;
  var touchStartY = null;


  photoViewport.addEventListener(
    'touchstart',
    function(event){

      if(
        !event.touches.length
      ){
        return;
      }


      touchStartX =
        event.touches[0]
          .clientX;


      touchStartY =
        event.touches[0]
          .clientY;


      stopPhotoAutoplay();

    },
    {
      passive:true
    }
  );


  photoViewport.addEventListener(
    'touchend',
    function(event){

      if(
        touchStartX === null ||
        !event.changedTouches.length
      ){

        startPhotoAutoplay();

        return;

      }


      var endX =
        event.changedTouches[0]
          .clientX;


      var endY =
        event.changedTouches[0]
          .clientY;


      var diffX =
        endX -
        touchStartX;


      var diffY =
        endY -
        touchStartY;


      if(
        Math.abs(diffX) > 45 &&
        Math.abs(diffX) >
        Math.abs(diffY)
      ){

        if(diffX < 0){

          nextPhoto();

        }else{

          previousPhoto();

        }

      }


      touchStartX = null;
      touchStartY = null;


      startPhotoAutoplay();

    },
    {
      passive:true
    }
  );



  

  var reviewViewport =
    root.querySelector(
      '.lr-review-viewport'
    );


  var reviewTrack =
    root.querySelector(
      '.lr-review-track'
    );


  var reviewCards =
    root.querySelectorAll(
      '.lr-card'
    );


  var reviewPrev =
    root.querySelector(
      '.lr-prev'
    );


  var reviewNext =
    root.querySelector(
      '.lr-next'
    );


  var reviewDotsWrap =
    root.querySelector(
      '.lr-review-dots'
    );


  var reviewPage = 0;



  

  function cardsPerView(){

    if(
      window.innerWidth <=
      640
    ){
      return 1;
    }


    if(
      window.innerWidth <=
      900
    ){
      return 2;
    }


    return 3;

  }



  

  function reviewPageCount(){

    return Math.ceil(
      reviewCards.length /
      cardsPerView()
    );

  }



  

  function createReviewDots(){

    reviewDotsWrap.innerHTML =
      '';


    if(
      window.innerWidth <=
      640
    ){
      return;
    }


    var pages =
      reviewPageCount();


    for(
      var i = 0;
      i < pages;
      i++
    ){

      var dot =
        document.createElement(
          'button'
        );


      dot.type =
        'button';


      dot.className =
        'lr-review-dot';


      dot.setAttribute(
        'data-page',
        i
      );


      dot.setAttribute(
        'aria-label',
        'Review page ' +
        (i + 1)
      );


      if(
        i === reviewPage
      ){

        dot.classList.add(
          'active'
        );

      }


      dot.addEventListener(
        'click',
        function(){

          reviewPage =
            parseInt(
              this.getAttribute(
                'data-page'
              ),
              10
            ) || 0;


          updateReviews();

        }
      );


      reviewDotsWrap.appendChild(
        dot
      );

    }

  }



  

  function updateReviews(){

    if(
      window.innerWidth <=
      640
    ){

      reviewTrack.style.transform =
        'none';

      return;

    }


    var per =
      cardsPerView();


    var pages =
      reviewPageCount();


    reviewPage =
      Math.max(
        0,
        Math.min(
          reviewPage,
          pages - 1
        )
      );


    var gap = 15;


    var viewportWidth =
      reviewViewport
        .clientWidth;


    var cardWidth =
      (
        viewportWidth -
        gap *
        (per - 1)
      ) /
      per;


    var requestedStart =
      reviewPage *
      per;


    var maxStart =
      Math.max(
        0,
        reviewCards.length -
        per
      );


    var start =
      Math.min(
        requestedStart,
        maxStart
      );


    reviewTrack.style.transform =
      'translate3d(-' +
      (
        start *
        (
          cardWidth +
          gap
        )
      ) +
      'px,0,0)';


    var dots =
      reviewDotsWrap.querySelectorAll(
        '.lr-review-dot'
      );


    dots.forEach(
      function(dot,index){

        dot.classList.toggle(
          'active',
          index ===
          reviewPage
        );

      }
    );


    reviewPrev.disabled =
      reviewPage === 0;


    reviewNext.disabled =
      reviewPage >=
      pages - 1;

  }



  

  reviewPrev.addEventListener(
    'click',
    function(){

      reviewPage =
        Math.max(
          0,
          reviewPage - 1
        );


      updateReviews();

    }
  );


  reviewNext.addEventListener(
    'click',
    function(){

      reviewPage =
        Math.min(
          reviewPageCount() - 1,
          reviewPage + 1
        );


      updateReviews();

    }
  );



  

  var previousCardsPerView =
    cardsPerView();


  window.addEventListener(
    'resize',
    function(){

      setPhotoPosition(
        false
      );


      photoTrack.offsetHeight;


      photoTrack.style.transition =
        photoTransition;


      var currentCardsPerView =
        cardsPerView();


      if(
        currentCardsPerView !==
        previousCardsPerView
      ){

        previousCardsPerView =
          currentCardsPerView;


        reviewPage = 0;


        createReviewDots();

      }


      updateReviews();

    }
  );



  

  document.addEventListener(
    'visibilitychange',
    function(){

      if(document.hidden){

        stopPhotoAutoplay();

      }else{

        startPhotoAutoplay();

      }

    }
  );



  

  setPhotoPosition(
    false
  );


  createReviewDots();


  updateReviews();


  startPhotoAutoplay();


})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["niacinamide-foam-story"]) return;
  try {
    

(function () {
  var root = document.getElementById('n8x-product-story');
  if (!root) return;

  var button = root.querySelector('[data-n8x-scroll-top]');
  if (!button) return;

  if (button.dataset.n8xScrollReady === 'true') return;
  button.dataset.n8xScrollReady = 'true';

  button.addEventListener('click', function (event) {
    event.preventDefault();

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oral-page-layout"]) return;
  try {
    
function oralDeferredMediaInit(scope){var videos=(scope||document).querySelectorAll(".oral-page video[data-oral-autoplay]:not([data-oral-observed])");if(!videos.length)return;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){var video=entry.target;if(entry.isIntersecting){if(video.dataset.oralSrc){video.src=video.dataset.oralSrc;delete video.dataset.oralSrc;}video.querySelectorAll("source[data-oral-src]").forEach(function(source){source.src=source.dataset.oralSrc;delete source.dataset.oralSrc;});if(!video.dataset.oralLoaded){video.preload="metadata";video.load();video.dataset.oralLoaded="true";}video.muted=true;video.play().catch(function(){});}else{video.pause();}});},{rootMargin:"200px 0px",threshold:0});videos.forEach(function(video){video.dataset.oralObserved="true";observer.observe(video);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",function(){oralDeferredMediaInit(document);});}else{oralDeferredMediaInit(document);}document.addEventListener("shopify:section:load",function(event){oralDeferredMediaInit(event.target);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palette-reference"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('.pl-play');if(!button)return;const video=button.previousElementSibling;video.controls=true;video.play().then(()=>{button.hidden=true;}).catch(()=>{button.hidden=false;});});
document.addEventListener('click',event=>{const button=event.target.closest('[data-pl-dir]');if(!button)return;const strip=button.closest('.pl-section').querySelector('.pl-video-strip');strip.scrollBy({left:strip.clientWidth*Number(button.dataset.plDir),behavior:'smooth'});});
document.addEventListener('play',event=>{if(!event.target.matches('.pl-video-card video'))return;document.querySelectorAll('.pl-video-card video').forEach(video=>{if(video!==event.target)video.pause();});},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdrn-balm-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-pdrn-balm .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdrn-balm-story-12"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('vreruditeVideoSliderCustom');
    const cards = slider.querySelectorAll('.vrerudite-video-card-custom');
    const dots = document.querySelectorAll('.vrerudite-dot-custom');
    
    let isDown = false;
    let startX;
    let scrollLeft;
    let dragged = false;

    // 1. 处理鼠标拖动/滑块行为
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      dragged = false;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // 滑动灵敏度系数
      slider.scrollLeft = scrollLeft - walk;
      dragged = true;
    });

    // 2. 处理点击播放/暂停
    cards.forEach((card) => {
      const video = card.querySelector('video');
      card.addEventListener('click', () => {
        if (dragged) return; // 如果在拖拽则不触发点击播放

        // 暂停其他正在播放的视频
        cards.forEach(c => {
          if (c !== card && c.classList.contains('is-playing')) {
            c.querySelector('video').pause();
            c.classList.remove('is-playing');
          }
        });

        // 切换当前视频状态
        if (video.paused) {
          video.play();
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });
    });

    // 3. 联动更新分页指示点状态
    slider.addEventListener('scroll', () => {
      const width = slider.clientWidth;
      const scrollWidth = slider.scrollWidth - width;
      if (scrollWidth <= 0) return;
      
      const progress = slider.scrollLeft / scrollWidth;
      const activeIndex = Math.min(
        Math.floor(progress * dots.length),
        dots.length - 1
      );

      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('vrerudite-active');
        } else {
          dot.classList.remove('vrerudite-active');
        }
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdrn-balm-story-5"]) return;
  try {
    

(function() {
  var sliders = document.querySelectorAll('.vrerudite-comparison-slider');

  sliders.forEach(function(slider) {
    var input = slider.querySelector('.vrerudite-slider-input');
    var overlay = slider.querySelector('.vrerudite-before-overlay');
    var line = slider.querySelector('.vrerudite-slider-line');

    function updateSlider(value) {
      overlay.style.width = value + '%';
      line.style.left = value + '%';
    }

    input.addEventListener('input', function() {
      updateSlider(this.value);
    });

    updateSlider(input.value);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-serum .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-story-1"]) return;
  try {
    

  (function() {
    const sectionEl = document.getElementById("videoCards-template--20409154502827__video_cards_XetJP3");
    if (!sectionEl) return;

    const track = sectionEl.querySelector(".video-cards-track");
    const btnR = sectionEl.querySelector(".carousel-arrow.right");
    const btnL = sectionEl.querySelector(".carousel-arrow.left");

    if (!track) return;

    let activeOverlay = null;

    function getScrollAmount() {
      const card = track.querySelector(".video-card");
      if (!card) return 180;
      const gap = 12;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      if (!btnL || !btnR) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      btnL.disabled = track.scrollLeft <= 5;
      btnR.disabled = track.scrollLeft >= maxScroll - 5;
    }

    function closeActive() {
      if (!activeOverlay) return;
      const v = activeOverlay.querySelector(".vc-video");
      if (v) {
        v.pause();
        v.currentTime = 0;
      }
      activeOverlay.remove();
      activeOverlay = null;
      document.body.classList.remove("vc-lock-scroll");
    }

    function openModal(card) {
      const tpl = card.querySelector(".video-modal-template");
      if (!tpl) return;

      closeActive();

      const fragment = tpl.content.cloneNode(true);
      const overlay = fragment.querySelector(".vc-overlay");
      const closeBtn = fragment.querySelector(".vc-close");
      const video = fragment.querySelector(".vc-video");

      if (!overlay) return;

      document.body.appendChild(overlay);
      activeOverlay = overlay;
      document.body.classList.add("vc-lock-scroll");

      if (video) {
        video.currentTime = 0;
        video.muted = false;
        video.play().catch(function() {});
      }

      if (closeBtn) {
        closeBtn.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeActive();
        });
      }

      overlay.addEventListener("click", function(e) {
        const modal = overlay.querySelector(".vc-modal");
        if (modal && !modal.contains(e.target)) {
          closeActive();
        }
      });
    }

    if (btnR) {
      btnR.addEventListener("click", function() {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: "smooth"
        });
      });
    }

    if (btnL) {
      btnL.addEventListener("click", function() {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: "smooth"
        });
      });
    }

    sectionEl.querySelectorAll(".video-card").forEach(function(card) {
      const playBtn = card.querySelector(".play-button");
      const preview = card.querySelector(".video-preview");

      if (playBtn) {
        playBtn.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          openModal(card);
        });
      }

      if (preview) {
        preview.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          openModal(card);
        });
      }

      card.addEventListener("click", function(e) {
        if (e.target.classList.contains("play-button")) return;
        if (e.target.classList.contains("video-preview")) return;
        openModal(card);
      });
    });

    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape") closeActive();
    });

    track.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    setTimeout(updateArrows, 150);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-story-10"]) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function() {
    var products = document.querySelectorAll(".rw-container-contant");
    var loadMoreBtn = document.getElementById("loadMore");
    var visibleProductsCount = 0;
    var productsPerPage = 2;

    function showProducts() {
      for (var i = visibleProductsCount; i < visibleProductsCount + productsPerPage; i++) {
        if (products[i]) {
          products[i].style.display = "block";
        }
      }
      visibleProductsCount += productsPerPage;

      if (visibleProductsCount >= products.length) {
        loadMoreBtn.style.display = "none";
      }
    }

    // 初始加载（前两条已在 HTML 中显示，此处分步展示剩余）
    // 如果初始两条已经显示，从第 2 条开始加载
    var initialVisible = 2;
    visibleProductsCount = initialVisible;

    // 确保前两条已显示
    for (var j = 0; j < initialVisible && j < products.length; j++) {
      products[j].style.display = "block";
    }

    // 如果总数少于等于 2，隐藏按钮
    if (products.length <= initialVisible) {
      loadMoreBtn.style.display = "none";
    }

    loadMoreBtn.addEventListener("click", function() {
      showProducts();
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-story-2"]) return;
  try {
    

  (function() {
    const track = document.getElementById('reviewTrack');
    const slides = track.querySelectorAll('.swiper-slide');
    const total = slides.length;
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    let currentIndex = 0;
    let isTransitioning = false;

    function getSlidesPerView() {
      const width = window.innerWidth;
      if (width >= 1024) return 3;
      if (width >= 768) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, total - getSlidesPerView());
    }

    function goTo(index) {
      const maxIndex = getMaxIndex();
      if (index < 0) index = 0;
      if (index > maxIndex) index = maxIndex;
      if (index === currentIndex || isTransitioning) return;

      isTransitioning = true;
      const perView = getSlidesPerView();
      const slideWidth = 100 / perView;
      track.style.transform = 'translateX(-' + (index * slideWidth) + '%)';
      currentIndex = index;

      setTimeout(function() {
        isTransitioning = false;
        updateButtons();
      }, 400);
    }

    function updateButtons() {
      const maxIndex = getMaxIndex();
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goTo(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goTo(currentIndex + 1);
    });

    // 响应式调整
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const maxIndex = getMaxIndex();
        if (currentIndex > maxIndex) {
          goTo(maxIndex);
        } else {
          const perView = getSlidesPerView();
          const slideWidth = 100 / perView;
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (currentIndex * slideWidth) + '%)';
          setTimeout(function() {
            track.style.transition = '';
          }, 50);
          updateButtons();
        }
      }, 200);
    });

    // 触摸滑动
    let startX = 0;
    let isDragging = false;
    const container = document.getElementById('reviewCarousel');

    container.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    container.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1);
      }
      isDragging = false;
    }, { passive: true });

    // 初始化
    updateButtons();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-story-5"]) return;
  try {
    

  (function() {
    const track = document.getElementById('mobileTrack');
    const slides = track ? track.querySelectorAll('.mobile-slide') : [];
    const prevBtn = document.getElementById('mobilePrev');
    const nextBtn = document.getElementById('mobileNext');

    if (!track || slides.length === 0 || !prevBtn || !nextBtn) return;

    let current = 0;
    let isTransitioning = false;

    function goTo(index) {
      if (isTransitioning) return;
      const total = slides.length;
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      if (index === current) return;
      isTransitioning = true;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      current = index;
      updateButtons();
      setTimeout(function() { isTransitioning = false; }, 350);
    }

    function updateButtons() {
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === slides.length - 1;
    }

    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goTo(current - 1);
    });

    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      goTo(current + 1);
    });

    // 触摸滑动
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
        // 垂直滚动，不处理
        return;
      }
      e.preventDefault();
      const offset = -(current * 100) + (dx / track.offsetWidth) * 100;
      track.style.transition = 'none';
      track.style.transform = 'translateX(' + offset + '%)';
    }, { passive: false });

    track.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.35s ease';
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) {
        dx > 0 ? goTo(current - 1) : goTo(current + 1);
      } else {
        goTo(current);
      }
    }, { passive: true });

    // 窗口变化时重置
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        goTo(current);
      }, 200);
    });

    updateButtons();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-story-8"]) return;
  try {
    

(function(){
  const items = document.querySelectorAll('.stat-item');

  const animateStats = (item) => {
    const target = parseInt(item.dataset.value, 10);
    const numberEl = item.querySelector('.stat-number');
    const bar = item.querySelector('.stat-fill');
    let current = 0;

    bar.style.width = target + '%';

    const interval = setInterval(()=>{
      if(current >= target){
        clearInterval(interval);
      } else {
        current++;
        numberEl.textContent = current + '%';
      }
    }, 15);
  };

  const observer = new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting && !entry.target.classList.contains('done')){
        entry.target.classList.add('done');
        animateStats(entry.target);
      }
    });
  }, { threshold:0.4 });

  items.forEach(item => observer.observe(item));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-story-9"]) return;
  try {
    

  (function () {
    if (window.innerWidth < 750) {
      document.documentElement.classList.add('faq-mobile-view');
    }
  })();


  (function () {
    'use strict';

    const sectionInstances = new WeakMap();
    const activeSections = new Set();

    let globalResizeHandler = null;
    let resizeHandlerAttached = false;

    class FAQSection {
      constructor(rootElement) {
        this.root = rootElement;
        this.clickHandler = null;
        this.mutationObserver = null;
        this.initialized = false;
      }

      init() {
        if (this.initialized) return;

        this.setupClickHandler();
        this.setupMutationObserver();
        this.updateResponsiveFontSizes();
        this.initialized = true;
      }

      setupClickHandler() {
        if (this.clickHandler) return;

        this.clickHandler = (e) => {
          const questionEl = e.target.closest('.store-faq-question');
          if (!questionEl || !this.root.contains(questionEl)) return;

          e.preventDefault();
          e.stopPropagation();

          const item = questionEl.closest('.store-faq-item');
          if (!item) return;

          const columnContainer = questionEl.closest('.store-faq-items-container');
          if (!columnContainer) return;

          const scopeIsAccordion = columnContainer.getAttribute('data-accordion') === 'true';

          if (scopeIsAccordion && !item.classList.contains('active')) {
            const activeItems = columnContainer.querySelectorAll('.store-faq-item.active');
            activeItems.forEach((other) => {
              if (other !== item && !other.classList.contains('mobile-only-item')) {
                other.classList.remove('active');
              }
            });
          }

          item.classList.toggle('active');
        };

        this.root.addEventListener('click', this.clickHandler, true);
      }

      setupMutationObserver() {
        if (this.mutationObserver) return;

        this.mutationObserver = new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
              this.init();
              break;
            }
          }
        });

        this.mutationObserver.observe(this.root, { childList: true, subtree: true });
      }

      updateResponsiveFontSizes() {
        if (!this.root) return;

        const isMobile = window.innerWidth < 750;
        if (isMobile) {
          document.documentElement.classList.add('faq-mobile-view');
        } else {
          document.documentElement.classList.remove('faq-mobile-view');
        }
      }

      cleanup() {
        if (this.clickHandler) {
          this.root.removeEventListener('click', this.clickHandler, true);
          this.clickHandler = null;
        }

        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }

        this.initialized = false;
      }
    }

    function getOrCreateFAQSection(sectionId) {
      const root = document.querySelector(`#store-faq-${sectionId}`);
      if (!root) return null;
      let instance = sectionInstances.get(root);

      if (!instance) {
        instance = new FAQSection(root);
        sectionInstances.set(root, instance);
        activeSections.add(instance);
      }

      return instance;
    }

    // Start FAQ section
    function initFAQ() {
      const instance = getOrCreateFAQSection('template--27184228270409__store_faq_VnwWnx');
      if (!instance) {
        setTimeout(initFAQ, 100);
        return;
      }

      instance.init();
    }

    function cleanupFAQ() {
      const root = document.querySelector('#store-faq-template--27184228270409__store_faq_VnwWnx');
      if (!root) return;

      const instance = sectionInstances.get(root);
      if (instance) {
        instance.cleanup();
        activeSections.delete(instance);
        sectionInstances.delete(root);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFAQ);
    } else {
      initFAQ();
    }

    // Shopify JS hooks
    document.addEventListener('shopify:section:load', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--27184228270409__store_faq_VnwWnx') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:select', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--27184228270409__store_faq_VnwWnx') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:reorder', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--27184228270409__store_faq_VnwWnx') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:unload', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--27184228270409__store_faq_VnwWnx') return;
      cleanupFAQ();
    });
    // Redundancy fallback
    window.addEventListener('load', initFAQ);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweat-patches-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-sweat-patches .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tree-page-layout"]) return;
  try {
    
function treeVideoInit(){document.querySelectorAll(".oral-tree .product__description video").forEach(function(v){v.muted=true;v.controls=true;var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{threshold:0.1});observer.observe(v);});}if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",treeVideoInit);}else{treeVideoInit();}

  } catch(e) { console.error(e); }
})();
})();
